module.exports = __webpack_public_path__ + "static/media/touxiang.9594c94b.png";